import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { NavigateByNavigationPath } from '../store/actions';

export const navigateByNavigationPathGuard: CanActivateFn = (route) => {
  const store = inject(Store);

  if (route.params['navigationPath']) {
    store.dispatch(
      new NavigateByNavigationPath({
        navigationPath: route.params['navigationPath'],
        queryParams: route.queryParams,
        isCustomizationMode: route.routeConfig?.path == ':navigationPath/customizations',
      }),
    );
  }

  return of(true);
};
